import React, { FunctionComponent, useContext } from 'react';
import { ILink } from 'bit/shared/declarations/index';
import { Link as BitLink } from 'bit/shared/link';
import { useLpEcosystemNavigation } from '@/hooks/useLpEcosystemNavigation';
import useGlobal from '@/hooks/useGlobal';
export interface ILinkProxy extends ILink {
  role?: string;
  tabIndex?: number;
  keepQuery?: boolean;
  className?: string;
}

export const Link: FunctionComponent<ILinkProxy> = (props) => {
  const global = useGlobal();

  const { internalHrefSlug, externalHrefSlug } = useLpEcosystemNavigation({
    internalHref: props.internalHref,
    externalHref: props.externalHref,
  });

  const defaultKeepQueryValue = props.keepQuery ?? true;

  // if this link is inside of an lp, compute lp Ecosystem slug.
  return (
    <BitLink
      updateGlobal={global?.emit.update}
      role={props?.role}
      tabIndex={props?.tabIndex}
      keepQuery={defaultKeepQueryValue}
      {...{
        ...props,
        internalHref: {
          ...props.internalHref,
          slug: internalHrefSlug, //update the slug as per lp value
        },
        externalHref: externalHrefSlug,
      }}
    />
  );
};
